import React from "react";
import styled from "styled-components";

import { colors } from "../../../theme";
import Skeleton from "../../components/layout/skeleton";

const FAQ_COUNT = 8;

const AccordionStack = styled.div`
  display: flex;
  flex-direction: column;
`;

/** Matches AccordionSection: surface chip, 12px radius, 0.5rem bottom gap. */
const AccordionBone = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin: 0 0 0.5rem;
  padding: 0 1.5rem;
  height: 52px;
  background: ${colors.surface};
  border-radius: 12px;

  @media (min-width: 1024px) {
    height: 66px;
  }
`;

const AccordionTitleBone = styled(Skeleton)`
  height: 21px;
  width: 55%;
  max-width: 280px;
  border-radius: 4px;

  @media (min-width: 768px) {
    height: 23px;
    width: 45%;
  }
`;

const FaqSkeleton = () => (
  <AccordionStack aria-hidden>
    {Array.from({ length: FAQ_COUNT }, (_, index) => (
      <AccordionBone key={index}>
        <AccordionTitleBone />
      </AccordionBone>
    ))}
  </AccordionStack>
);

export default FaqSkeleton;
